export default __webpack_public_path__ + "static/media/tick-circle.4da47154.svg";